(function () {
  const originalFetch = window.fetch;

  window.fetch = function (input, init) {
    return originalFetch(input, init).then(function (response) {
      if (response.ok) {
        const url = response.url;

        const cartEndpoints = [
          '/cart/add.js',
          '/cart/change',
          '/cart/change.js',
          '/cart/update.js',
          '/cart/clear.js',
        ];

        const isCartChange = cartEndpoints.some(endpoint =>
          url.includes(endpoint)
        );

        // Block reload if it's a cart event — app will handle the logic
        if (isCartChange) {
          console.log('[Quiz Kit Patch] Prevented page reload after cart change.');
          sessionStorage.setItem('salesMotivatorGiftTriggered', 'true');
        }
      }

      return response;
    });
  };
})();